import { render, staticRenderFns } from "./ProcessRiskPoint.vue?vue&type=template&id=2925421e&scoped=true"
import script from "./ProcessRiskPoint.vue?vue&type=script&lang=js"
export * from "./ProcessRiskPoint.vue?vue&type=script&lang=js"
import style0 from "./ProcessRiskPoint.vue?vue&type=style&index=0&id=2925421e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2925421e",
  null
  
)

export default component.exports